import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-inwards-transaction',
  templateUrl: './inwards-transaction.component.html',
  styleUrls: ['./inwards-transaction.component.scss']
})
export class InwardsTransactionComponent implements OnInit {

  static that: InwardsTransactionComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;

  @Input() shipmentModetypearray: any = [];
  @Input() parentTypearray: any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
  ) {
    InwardsTransactionComponent.that = this;
  }

  ngOnInit() {

    // console.log(this.shipmentModetypearray , "this is shipmentmodetypearray!");
    // console.log(this.parentTypearray , "this is parentTypearray!");

    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);


    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');

    this.initalizeForm();

  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['Id']) {
    //   this.Id = changes['Id'].currentValue;
    //   if (this.Id) {
    //     this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
    //   }
    // }
  }

  async initalizeForm() {
    this.tableDetails = {
      data: [],
      emptyDataMSg: "No Records Found",
      columnDetails: [
        { columnName: "Inward No", dataFieldName: "OrderNo", dataFieldName2: "OrderDate", divType: "ftlOrders", color: "var(--colors-primary-blue-blue-200, #3367FB)", },
        { columnName: "PO No", dataFieldName: "PONo", dataFieldName2: "PODate", divType: "ftlOrders", color: "var(--colors-primary-blue-blue-200, #3367FB)", },
        { columnName: "Invoice No", dataFieldName: "InvoiceNo", divType: "ftlOrders", color: "var(--colors-primary-blue-blue-200, #3367FB)", },
        { columnName: "Shipper", dataFieldName: "Customer", dataFieldName2: "PickupLocationCode", },
        { columnName: "Ship To Party", dataFieldName: "warehouseName", dataFieldName2: "DeliveryLocationCode", },
        { columnName: 'Bill To Party', dataFieldName: 'BillToBranch' },
        { columnName: "Shipment Reference No", dataFieldName: "ShipmentRefNo", divType: "ftlOrders", color: "var(--colors-primary-blue-blue-200, #3367FB)", },
        { columnName: "Cost", dataFieldName: "Cost", divType: "ftlOrders" },
        { columnName: "Qty in Case", dataFieldName: "CaseQty", divType: "" },
        { columnName: 'Total Qty', dataFieldName: 'totalQty', divType: '', alignType: 'right' },
        { columnName: "Weight", dataFieldName: "Weight", divType: "", alignType: "right", },
        {
          columnName: "Amount",
          dataFieldName: "Amount",
          divType: "",
          alignType: "right",
        },
        { columnName: "Status", dataFieldName: "GIStatus", divType: "status" },
      ],
      isColumnNameShow: true,
    }
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {

    Helpers.setLoading(true);

    if (CompanyId !== undefined && CompanyId !== null) {
      this.CompanyId = CompanyId;
    }

    this.payload.Start = pageNo * perPage;
    this.payload.PerPage = perPage;
    this.payload.SearchValue = searchValue || null;
    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
    this.payload.OrderNo = null;

    console.log(this.shipmentModetypearray, "this is shipmentmodetypearray :");

    if (this.shipmentModetypearray.includes('supplier') || this.parentTypearray.includes('supplier') || this.shipmentModetypearray.includes('vendor') || this.parentTypearray.includes('vendor')) {
      this.payload.CustomerName = Id ? Id : this.Id;
      // this is supplier
    }
    else {
      this.payload.CustomerName = null;
    }
    // this.payload.CustomerName = Id ? Id : this.Id;
    this.payload.ShipTo = null;
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null;

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;



    // if(this.shipmentModetypearray.includes('Supplier') || this.parentTypearray.includes('Vendor')){
    //   this.payload.BillToParty=Id ? Id : this.Id;
    // }
    if (this.shipmentModetypearray.includes('Warehouse') || this.shipmentModetypearray.includes('Warehouse/CFS/Yard')) {
      this.payload.warehouseId = Id ? Id : this.Id;
    }

    this._appService.Post("OrdersByVehicle", "obv_GetGIList_NewFlow", this.payload)
      .subscribe((response) => {
        if (response.length) {
          this.totalCount = response[0].recordcount;
          // this.isListApiCalled = true;
        }
        this.assignTableFields(pageNo, perPage, response)
        Helpers.setLoading(false);
      },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error("Error while fetching data", err);
        }
      );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }


  GetTransactionListDownload(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id
  ) {
    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);

    // this.payload.Start = pageNo * perPage;
    // this.payload.Length = this.totalCount;
    // this.payload.SearchValue = searchValue;
    // this.payload.CompanyId = this.CompanyId;
    // this.payload.FromDate = this.data.FromDate;
    // this.payload.ToDate = this.data.ToDate;
    // this.payload.Id = this.Id;
    // this.payload.ReferenceType = this.referenceType;
    // this.payload.UserId= this.userId;

    this.payload.Start = pageNo;
    this.payload.PerPage = this.totalCount;
    this.payload.SearchValue = searchValue || null
    this.payload.CompanyId = this.CompanyId
    this.payload.OrderNo = null;
    this.payload.CustomerName = Id ? Id : this.Id;
    this.payload.ShipTo = null;
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null


    this._appService.Post("OrdersByVehicle", "GoodsInwardDownload", this.payload).subscribe((response) => {
      this.DownloadFile(response);
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while downloading", error);
      }
    );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

}
